import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeBorderVariable, ThemeColorVariable, ThemeFontSizeVariable, ThemeFontVariable, ThemeRadiusVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Box, chakra, useRadio, } from '@chakra-ui/react';
import React from 'react';
import { hoverStylesCard } from './radio.hoverstyles';
/**
 * Custom Radio input that appears as a colored button when in "isChecked"-state.
 * Internally uses Chakras useRadio-hook to provide the elements within with the
 * props required for it to work as a real radio, compatible with FormControl etc.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/radio
 */
export const RadioCard = React.forwardRef(({ children, id, name, value, isChecked, defaultChecked, isDisabled, isFocusable, isReadOnly, isInvalid, isRequired, onChange, alignItems = 'center', alignContent = 'center', ...props }, ref) => {
    const { getInputProps, getRadioProps, htmlProps, getLabelProps } = useRadio({
        id,
        name,
        value,
        isChecked,
        defaultChecked,
        isDisabled,
        isFocusable,
        isReadOnly,
        isInvalid,
        isRequired,
        onChange,
        ...props,
    });
    const labelProps = getLabelProps();
    const inputProps = getInputProps();
    const radioProps = getRadioProps();
    return (_jsx(Box, { as: "span", __css: hoverStylesCard, w: "100%", children: _jsxs(chakra.label, { ...labelProps, ...htmlProps, cursor: "pointer", textAlign: "center", children: [_jsx("input", { ...inputProps, ref: ref }), _jsx(Box, { ...radioProps, ...props, className: "chakra-radio__control", whiteSpace: "nowrap", alignContent: alignContent, alignItems: alignItems, fontFamily: ThemeFontVariable.Body, fontSize: ThemeFontSizeVariable.Medium, bg: ThemeColorVariable.Surface, border: ThemeBorderVariable.XSmall, borderColor: ThemeColorVariable.OnSurfaceBorder, borderRadius: ThemeRadiusVariable.Small, px: ThemeSpaceVariable.Medium, py: ThemeSpaceVariable.Small, textColor: ThemeColorVariable.OnSurface, _checked: {
                        textColor: ThemeColorVariable.OnAccent,
                        bg: ThemeColorVariable.Accent,
                        borderColor: ThemeColorVariable.Accent,
                    }, _disabled: {
                        opacity: 0.48,
                        _checked: {
                            bg: ThemeColorVariable.Accent,
                            color: ThemeColorVariable.OnAccent,
                        },
                    }, _active: {
                        background: ThemeColorVariable.AccentActiveAlpha,
                        _checked: {
                            background: ThemeColorVariable.AccentActive,
                        },
                        _disabled: {
                            background: ThemeColorVariable.Surface,
                            _checked: {
                                background: ThemeColorVariable.Accent,
                            },
                        },
                    }, _invalid: {
                        border: ThemeBorderVariable.XSmall,
                        borderColor: ThemeColorVariable.Error,
                        boxShadow: `0 0 0 4px ${ThemeColorVariable.ErrorContainer}`,
                    }, children: children })] }) }));
});
//# sourceMappingURL=radio-card.js.map